module.exports = __webpack_public_path__ + "img/6.befb0166.png";